import React, { useEffect, useState } from 'react'
import './todo.css'
import { Link } from 'react-router-dom'
import { getUserTasks, submitTask } from '../../api/taskApi'
import { useDispatch, useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import Loader from '../../components/loader/Loader'
import profile from '../../assets/profile.png'
import TodoCard from './TodoCard'
import TodoChart from '../../components/doughnutChart/TodoChart'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { userLogin } from '../../state/userSlice'
import { handleAddTask } from '../../state/taskSlice'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import { getAllAcounts} from '../../api'
import {handleUsers} from '../../state/userSlice'
import moment from 'moment'

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


// SUBMIT TASK FORM
const AddTask = ({setToggleTask, user, users, handleGetTasks})=>{
  const [isLoading , setIsLoading ] = useState(false)
  const [teamArray, setTeamArray] = useState([])
  const [checked, setChecked] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const dispatch = useDispatch()    
    
  const {
    register,
    handleSubmit,
    formState:{errors},
    control,
    reset,
  } = useForm({
    mode: 'onChange'
  })
  // HANDLE TEAM ARRAY
  const handleTeamArray = (id) => {
    if (teamArray.includes(id)) {
        setTeamArray(teamArray.filter(itemId => itemId !== id));
    } else {
        setTeamArray([...teamArray, id]);
    }
};

  // HANDLE SUBMIT TASKS FUNCTION
  const handleSubmitTask = async (data)=>{
    setIsLoading(true)
    try {
        const formData = new FormData()
        const {title, description, status } = data
        formData.append('title', title)
        formData.append('description', description)
        formData.append('status', status)
        formData.append('teamArray', teamArray ? teamArray : [])
        formData.append('upload', selectedFile)
        const res = await submitTask(user?.token, formData)
        setToggleTask(false)
        if(res?.success){
            reset()
            MySwal.fire({
              icon: 'success',
              title: res?.message,
              showConfirmButton: false,
              timer: 2000
            });
            handleGetTasks()
            dispatch(handleAddTask(res?.data))
            const newData = {token: res?.token, ...res?.user}
            dispatch(userLogin(newData))
        }else{
          MySwal.fire({
            icon: 'error',
            title: res?.message,
            showConfirmButton: false,
            timer: 2000
          });
        }
        setIsLoading(false)
      } catch (error) {
        console.log(error)
        setIsLoading(false)
        MySwal.fire({
          icon: 'error',
          title: "There's an error processing your request, Try again",
          showConfirmButton: false,
          timer: 2000
        });
    }
  }

  return (
    <div className='modal' 
    onClick={()=>setToggleTask(false)}>
      
      <div className="modal-container">
        <div className="modal-content overflow" 
        onClick={(e)=>e.stopPropagation()}>
          {/* TODO FORM */}
          <form className="modal-form" 
          onSubmit={handleSubmit(handleSubmitTask)}
          >
            {/* FORM HEADING */}
            <div className="modal-heading">
              {/* TITLE */}
              <h4 className="modal-title">
                Submit Todo List
              </h4>
              {/* CLOSE BUTTON */}
              <button onClick={()=>setToggleTask(false)}
              className="modal-btn">
                <i class='bx bx-x'></i>
              </button>
            </div>

            {/* TITLE */}
            <div className="modal-field">
              <label htmlFor="title" className="modal-label">Title</label>
              <input type="text" id="title" name="title"
                className='modal-input'
                {...register('title',{required: 'This field is required'})}
                placeholder="Enter task title..." 
              />
              {errors.title && <span className="modal-error">
                {errors.title.message}
              </span>}
            </div>
            
            {/* DESCRIPTION */}
            <div className="modal-field">
              <label htmlFor="todo" className="modal-label">
                Description
              </label>

              <Controller
                name="description"
                control={control}
                defaultValue=""
                rules={{required: 'This field is required'}}
                render={({ field }) => (
                  <ReactQuill
                    name="description"
                    theme="snow"
                    value={field.value}
                    onChange={(content) => field.onChange(content)}
                    style={{width: '100%'}}
                  />
                )}
              />

              {errors.description && <span className="modal-error">
                {errors.description.message}
              </span>}
            </div>

            {/* STATUS */}
            <div className="modal-field">
              <label htmlFor="title" className="modal-label">
                Status
              </label>
              <div className="addtodo__form-status">
                <div className="addtodo__form-status_div">
                  <input type="radio" name="status" id='radio1' 
                  {...register('status',{
                  required: 'This field is required!'})}
                  className="add__form-status_input" value="InProgress"/>
                  <label htmlFor='radio1' className="add__form-status_label">
                      InProgress
                  </label>
                </div>
                <div className="addtodo__form-status_div">
                  <input type="radio" name="status" id='radio2'
                  {...register('status',{
                  required: 'This field is required!'})} 
                  className="add__form-status_input" value="Waiting"/>
                  <label htmlFor='radio2' className="add__form-status_label">
                      Waiting
                  </label>
                </div>
                <div className="addtodo__form-status_div">
                  <input type="radio" name="status" id='radio3' 
                  {...register('status',{
                  required: 'This field is required!'})}
                  className="add__form-status_input" value="Completed"/>
                  <label htmlFor='radio3' className="add__form-status_label">
                      Completed
                  </label>
                </div>
              </div>
              {errors.status && <span className="modal-error">
                {errors.status.message}</span>}
            </div>
            
            {/* ATTACHMENT */}
            <div className="modal-field">
                <label htmlFor="upload" className="modal-label">
                  Attachment
                </label>
                <input onChange={(e)=>setSelectedFile(e.target.files[0])}
                type="file" name="upload" 
                className="addtodo__form-input" />
            </div>

            {/* ASSIGN */}
            {
              user?.role === 'Supervisor' && 
              <div className="addtodo__form-item">
                <div className="addtodo__form-item_assign">
                  <label htmlFor="assign" className="addtodo__form-label">Asign To:</label>
                  <input checked={checked}
                  onChange={()=>setChecked(!checked)}
                  type="checkbox" name="assign" 
                  className="addtodo__form-item_input" />
                </div>
                {
                  checked && (
                    <div className="addtodo__form-item_team">
                      {users?.map((item, i)=>(
                        item?.department === user?.department && 
                        <div key={i}
                        onClick={()=>handleTeamArray(item)}
                        className={`addtodo__form-item_profile ${
                          teamArray.includes(item) ? 'active' : ''
                        }`}>
                          <img src={!user?.profilePic ? profile
                          : `https://aspomportal.netlify.app/upload/${item?.profilePic}`} 
                          alt={item?.firstName + ' ' + item?.lastName}
                          className="addtodo__form-item_img" />
                          <span className="addtodo__form-item_name">
                            {item?.firstName + ' ' + item?.lastName}
                          </span>
                        </div>
                      ))}
                    </div>
                  )
                }
              </div>
            }

            {/* SUBMIT BUTTON */}
            <div className="addtodo__form-item">
              {
                isLoading ? <Loader/> 
                : <button 
                type='submit'
                className="addtodo__form-button button">
                  Submit
                </button>
              }
            </div>
          </form>
        </div>
      </div>

    </div>
  )
}

const Todo = () => {
  const dispatch = useDispatch()  
  const {user, users} = useSelector((state)=> state.user)
  const [value, setValue] = useState(new Date().getMonth() + 1)
  const {task} = useSelector((state)=> state.task)
  const [toggleTask, setToggleTask] = useState(false)
  const [todoTab, setTodoTab] = useState('all')
  const [filteredByMonth, setFilteredByMonth] = useState()
  const [filteredArray, setFilteredArray] = useState([])
  const itemsPerPage = 12
  const [currentPage, setCurrentPage] = useState(1)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = Math.min(startIndex + itemsPerPage, filteredArray?.length)

  const totalArray = filteredArray?.slice(startIndex, endIndex)

  const handlePagination = (val) => {
    setCurrentPage(val)
  }

  const handlePrevPage = ()=>{
    if(currentPage > 1){
      setCurrentPage(currentPage - 1)
    }
  }

  const handleNextPage = ()=>{
    if(currentPage < Math.ceil(filteredArray?.length / itemsPerPage)){
      setCurrentPage(currentPage + 1)
    }
  }

  const handleGetUsers = async ()=>{
    try{
        const res = await getAllAcounts(user?.token)
        dispatch(handleUsers(res?.data))
    }catch(error){
        console.log(error)
    }
  }

  // HANDLE GET TASKS
  const handleGetTasks = async ()=>{
    try {
      const res = await getUserTasks(user?.token)
      dispatch(handleAddTask(res?.data))
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(()=>{
    handleGetTasks()
    handleGetUsers()
  },[])

  const handleFilter = (val)=>{
    setTodoTab(val)
  }
  
  const filteredTasks = task?.filter(item => {
    return moment(item?.month).month() === moment().month() && item?.todolist;
  });

  // useEffect(() => {
  //   if (task) {
  //     const filteredTasks = task?.filter(item => {
  //       return mo(item?.month) === String(value) && item?.todolist
  //     });
  //     setFilteredByMonth(filteredTasks);
  //   }
  // }, [task, value]);

  const todolistByMonth = filteredTasks ? filteredTasks[0]?.todolist : []


  useEffect(()=>{
    const filteredItem = todolistByMonth?.filter((task)=>{
        if(todoTab === 'all'){
          return task
        } else{
          return task?.status?.toLowerCase().includes(todoTab.toLowerCase())
        }
    })
    setFilteredArray(filteredItem)
  },[task, todoTab, value])


  return (
    <section className='todo'>
      
      {/* HEADING */}
      <div className="heading">
        <div className="heading__box">
          <div className="heading-item">
            <h3 className="heading-title">Todo List | </h3>
            <i class='bx bx-home heading__title-icon'></i>
            <Link to="/" className="heading-text">
              Home <i class='bx bx-chevron-right heading-icon'></i>
            </Link>
            <span className="heading-text">
              Todo list <i class='bx bx-chevron-right heading-icon'></i>
            </span>
          </div>
          <p className="heading-text">
            Add your tasks below.
          </p>
        </div>
        <button 
        onClick={()=>setToggleTask(!toggleTask)}
        className="heading__box-btn button">
            Add Todo
        </button>
      </div>

      <div className="todo__container">
        <div className="todo__container-left">
          {/* TODO TABS */}
          <div className="todo__tabs">
            <h4 className="todo__tabs-title">
              {moment().format('MMMM YYYY')}
            </h4>
            <button onClick={()=>handleFilter('all')}
            className={`todo__tab ${
              todoTab === 'all' && 'active'
            }`}>
              Todo <span className="todo__badge">{
                todolistByMonth?.length
              }</span>
            </button>
            <button onClick={()=>handleFilter('inProgress')}
            className={`todo__tab ${
              todoTab === 'inProgress' && 'active'
            }`}>
              InProgress <span className="todo__badge">{
                todolistByMonth?.filter((task)=>task?.status === 'InProgress')?.length ?? 0
              }</span>
            </button>
            <button onClick={()=>handleFilter('waiting')}
            className={`todo__tab ${
              todoTab === 'waiting' && 'active'
            }`}>
              Waiting <span className="todo__badge">
                {todolistByMonth?.filter((task)=>task?.status === 'Waiting')?.length ?? 0
                }
              </span>
            </button>
            <button onClick={()=>handleFilter('completed')}
            className={`todo__tab ${
              todoTab === 'completed' && 'active'
            }`}>
              Completed <span className="todo__badge">
                {todolistByMonth?.filter((task)=>task?.status === 'Completed')?.length ?? 0
                }
              </span>
            </button>
            {/* <div className="staff__attendance-search">
                <span className="staff__attendance-search_span">Search</span>
                <select name="search" id=""
                value={value} onChange={(e)=>setValue(e.target.value)}
                className="staff__attendance-search_input">
                    <option value={1}>January</option>
                    <option value={2}>February</option>
                    <option value={3}>March</option>
                    <option value={4}>April</option>
                    <option value={5}>May</option>
                    <option value={6}>June</option>
                    <option value={7}>July</option>
                    <option value={8}>August</option>
                    <option value={9}>September</option>
                    <option value={10}>October</option>
                    <option value={11}>November</option>
                    <option value={12}>December</option>
                </select>
            </div> */}
          </div>

          <div className="todo__content">

            {/* TODO LIST CARD CONTENT */}
            <TodoCard todoTasks={totalArray ?? []}/>

            {/* PAGINATIONS */}
            <div className="todo__paginations">
              <span className="todo__pagination-length">
                Showing 1 to {itemsPerPage} of {filteredArray?.length}
              </span>
              <div className="todo__pagination-buttons">
                <button onClick={handlePrevPage}
                className="todo__pagination-button">
                  Prev
                </button>
                {
                  filteredArray && filteredArray?.length > 0 && 
                  [...Array(Math.ceil(filteredArray?.length / itemsPerPage))?.keys()].map((pageNum) => (
                    <button 
                      key={pageNum} 
                      onClick={() => handlePagination(pageNum + 1)}
                      className={`todo__pagination-button ${
                        currentPage === pageNum + 1 ? 'active' : ''
                      }`}
                    >
                      {pageNum + 1}
                    </button>
                  ))
                }
                <button onClick={handleNextPage}
                className="todo__pagination-button">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="todo__container-right">
          <TodoChart task={todolistByMonth}/>
        </div>
      </div>

      {toggleTask && <AddTask user={user}
      handleGetTasks={handleGetTasks}
      users={users}
      setToggleTask={setToggleTask} 
      toggleTask={toggleTask}/>}
    </section>
  )
}

export default Todo